<template>
	<div class="header-logo-container">
		<img :alt="`${getStoreName} image`" @load="logoLoaded" src="../../../assets/store-logo.png">
		<p class="header-location"
			@click="_navigateToLocator">
			{{ displayStoreLocation }}
		</p>
	</div>
</template>

<script>
	import HeaderLogo from './HeaderLogo';
	import locationsMixin from '@Mixin/locationsMixin';
	export default {
		extends: HeaderLogo,
		mixins: [
			locationsMixin,
		],
		computed: {
			displayStoreLocation() {
				return this.storeLocality;
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '@style-vars';
	@include mobile {
		.header-logo-container {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			height: $mobileNavigationHeight;
			img {
				max-height: 36px;
				max-width: 36px;
			}
			&.wide-logo {
				img {
					width: 33vw;
					max-width: 160px;
					object-fit: contain;
				}
			}
			.header-location {
				padding-top: 4px;
				margin-bottom: -4px;
				font-size: 0.8em;
				font-weight: bold;
				color: $storeButtonColor;
				min-height: 1.6em;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/header/NavigationItems/HeaderLogoLocation.vue